module.exports = __webpack_public_path__ + "static/img/Boss_31071.1d0f89ef.png";